import { useTrialInformation } from './useTrialInformation.js'

export const useTrialStatus = () => {
  const { isTrial, isActive, isManual, trialEndDate, isLoading } =
    useTrialInformation()

  if (isLoading || isManual || !isTrial) {
    return {
      isTrialExpired: false,
      isTrialActive: false,
      trialEndDate: null,
      isLoading,
    }
  }

  // `isActive` from the backend is the single source of truth for whether the
  // trial subscription is still usable. We must NOT re-derive expiry from
  // `trialEndDate` on the client and OR it in: clock skew, timezone parsing, or
  // a stale/boundary end date would then lock an active subscriber out of the
  // entire admin behind the non-dismissible trial-expired paywall. The backend
  // already reported the subscription active, so `trialEndDate` is used for
  // display only (e.g. the "X days left" badge), never for gating.
  const isTrialActive = isActive
  const isTrialExpired = !isTrialActive

  // `trialEndDate` is exposed for display only (the "X days left" badge/alert).
  // Only surface it when it parses AND is still in the future: a stale/past
  // date on an otherwise-active subscription would render through
  // `dayjs().fromNow(true)` as nonsense like "26 years remaining".
  const trialEndTime = trialEndDate ? new Date(trialEndDate).getTime() : null
  const hasFutureTrialEndDate =
    trialEndTime !== null &&
    !Number.isNaN(trialEndTime) &&
    trialEndTime > Date.now()

  return {
    isTrialExpired,
    isTrialActive,
    trialEndDate: isTrialActive && hasFutureTrialEndDate ? trialEndDate : null,
    isLoading,
  }
}
